// extracted by mini-css-extract-plugin
module.exports = {"DeliverySlotChecker":"DeliverySlotsChecker_DeliverySlotChecker__w98aN","DeliverySlotChecker__title":"DeliverySlotsChecker_DeliverySlotChecker__title__18PUe"};